import ConsumptionData from "./data";

export default function consumptionDataFromJson(json) {
    return new ConsumptionData(
        json.fuelLowSulfur,
        json.fuelOil,
        json.time
    )
}